// Primitives shared by the client-side polling loops (agent jobs, USDT
// deposits). client.js rejects plain { data, message, status } objects and
// reports axios' cancellation as a plain network error, hence the signal checks.

export const isAbortError = (error: unknown): boolean =>
  typeof error === "object" &&
  error !== null &&
  (error as { name?: unknown }).name === "AbortError";

export const abortReason = (signal: AbortSignal) =>
  signal.reason ?? new DOMException("The operation was aborted.", "AbortError");

// status is null when the request never reached the server. Anything else
// (404, 422, our own bugs) is not worth retrying.
export const isTransientError = (error: unknown) => {
  const status = (error as { status?: unknown } | null)?.status;
  return (
    status === null ||
    status === 429 ||
    (typeof status === "number" && status >= 500)
  );
};

export const sleep = (ms: number, signal?: AbortSignal) =>
  new Promise<void>((resolve, reject) => {
    if (signal?.aborted) {
      reject(abortReason(signal));
      return;
    }
    const onAbort = () => {
      clearTimeout(timer);
      reject(abortReason(signal!));
    };
    const timer = setTimeout(() => {
      signal?.removeEventListener("abort", onAbort);
      resolve();
    }, ms);
    signal?.addEventListener("abort", onAbort, { once: true });
  });
